import { render, staticRenderFns } from "./SipControlBar.vue?vue&type=template&id=2fd5714c&scoped=true"
import script from "./SipControlBar.vue?vue&type=script&lang=js"
export * from "./SipControlBar.vue?vue&type=script&lang=js"
import style0 from "./SipControlBar.vue?vue&type=style&index=0&id=2fd5714c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd5714c",
  null
  
)

export default component.exports